var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content m-0 p-0"},[_c('Nav'),_c('FadeTransition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1),_c('notifications',{attrs:{"group":"foo"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }